import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {SignUpFormComponent} from './sign-up-form.component';
import {CountrySelectModule} from '../country-select/country-select.module';
import {ButtonModule} from '../button/button.module';
import {ErrorMessageModule} from '../error-message/error-message.module';
import {LoadingModule} from '../loading/loading.module';
import {FormDividerModule} from '../form-divider/form-divider.module';
import {ValidatePhoneFormModule} from '../validate-phone-form/validate-phone-form.module';
import {PhoneCodeModule} from '../phone-code/phone-code.module';
import { ModalOkSingupModule } from 'src/app/ui/modals/modal-ok-singup/modal-ok-singup.component';

@NgModule({
  declarations: [SignUpFormComponent],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    ButtonModule,
    LoadingModule,
    PhoneCodeModule,
    FormDividerModule,
    ErrorMessageModule,
    ReactiveFormsModule,
    CountrySelectModule,
    ValidatePhoneFormModule,
    ModalOkSingupModule
  ],
  exports: [SignUpFormComponent],
})
export class SignUpFormModule { }
